module.exports = __webpack_public_path__ + "img/1436741305.a54dc2a9.jpg";